import './js/vendor/jquery.serializeObject';
import 'isotope-layout';
import './js/vendor/modernizr-3.11.2.min.js';
import './js/circularProgressBar.min.js';
import './js/lightcase.js';
import './js/waypoints.min.js';
import './js/wow.min.js';
import './js/vendor/bootstrap.bundle.min.js';
import './js/plugins.js';
import './js/main.js';
// import './css/bootstrap.min.css';
import './css/animate.css';
import './css/icofont.min.css';
import './css/swiper.min.css';
import './css/lightcase.css';
import './css/style.min.scss';
import './css/theme.scss';
import './js/nfts';
